export default __webpack_public_path__ + "static/national-metric-mobile-75e0655a37d035143ec3e6fbbf31fe32.svg";